<template>
    <div class="w-view-shell">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页:开始学习</el-breadcrumb-item>
            <el-breadcrumb-item :to="{}">模拟考题</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="topic-list-shell">
            <div class="box" v-for="(item2,index2) in topic_list" :key="index2">
                <div class="herd">
                    <button class="btn">{{item2.qst_type | setType}}</button>
                    <div class="nuber" v-if="index2==0">{{current_topic}}/{{topic_list.length}}</div>
                </div>
                <div class="topic">
                    {{index2+1}}.{{item2.qst_name}}
                </div>

                <div class="content">
                    <div class="option-box" v-for="(item,index) in item2.qst_info" :key="index">
                        <div class="select-box" @click.stop="select_option(item,index,index2)">
                            <img src="@/assets/icon_check.png" alt="" v-if="item.is_select==1">
                            <img src="@/assets/cuowu.png" alt="" v-if="item.is_select==2">
                        </div>
                        <div class="option-val"> [{{ option_num[index]}}]. {{item.option}}</div>
                    </div>
                    <van-button v-if="item2.show_answer" class="conceal" @click="conceal(item2,index2)"
                    >隐藏答案
                    </van-button>
                    <van-button v-else class="conceals" @click="conceal(item2,index2)"
                    >显示答案
                    </van-button>
                    <span class="ok" v-show="item2.show_answer">
                        正确答案：
                        <span v-for="(item3,index3) in item2.qst_answer"
                     :key="index3 + 'b'">{{option_num[item3-1]}}</span>
                    </span>
                </div>
            </div>
        </div>
        <el-button class="Btn1" @click.stop="paper">完成练习</el-button>
    </div>
</template>

<script>
  // import { MessageBox } from 'element-ui'

  export default {
    name: 'consolidate',
    data () {
      return {
        current_topic: 0,
        cnt_course: 0,
        sqeq: false,
        topic_list: [],
        course_id: '',
        directory_id: '',
        option_num: [
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H'
        ],
        time: 3600,
        use_time: 0,
        down_tips: '',
        course_type: 1
      }
    },
    filters: {
      setType (value) {
        if (value == 0) {
          return '单选'
        }
        if (value == 1) {
          return '多选'
        }
        if (value == 2) {
          return '判断'
        }
      }
    },
    mounted () {
      this.course_id = this.$route.query.course_id
      this.directory_id = this.$route.query.directory_id
      this.course_type = this.$route.query.course_type
      if (this.course_type == 2) {
        this.get_pher_list()
      } else {
        this.get_list()
      }
      this.down_time()
    },
    methods: {
      down_time () { // 答题倒计时
        let d = 0
        let h = 0
        let m = 0
        let s = 0
        let time = this.time
        this.use_time = 0
        this.timer = setInterval(() => {
          if (time === 0) {
            return clearInterval(this.timer)
          }
          time--
          this.use_time++
          d = parseInt(time / (24 * 60 * 60))
          h = parseInt(time / (60 * 60) % 24)
          m = parseInt(time / 60) < 10 ? '0' + parseInt(time / 60) : parseInt(time / 60)
          s = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
          this.down_tips = m + ':' + s
        }, 1000)
      },
      count_select () {
        let select_num = 0
        for (let i = 0; i < this.topic_list.length; i++) {
          if (this.topic_list[i].answer) {
            select_num += 1
          }
        }
        this.current_topic = select_num
      },
      select_option (item, index, index2) {
        if (this.topic_list[index2].is_error) { //   多选 答错
          return
        }
        let answers = []
        if (this.topic_list[index2].qst_type === 1) { // 多选
          if (this.topic_list[index2].qst_answer.indexOf(index + 1) !== -1) {
            this.topic_list[index2].qst_info[index].is_select = 1
          } else {
            this.topic_list[index2].is_error = true
            this.topic_list[index2].qst_info[index].is_select = 2
          }
          for (let i = 0; i < this.topic_list[index2].qst_info.length; i++) {
            if (this.topic_list[index2].qst_info[i].is_select) {
              answers.push(i)
            }
          }
        } else { // 单选
          if (this.topic_list[index2].answer) { // 单选已答  或
            return
          }
          if (this.topic_list[index2].qst_answer.indexOf(index + 1) !== -1) {
            this.topic_list[index2].qst_info[index].is_select = 1
          } else {
            this.topic_list[index2].qst_info[index].is_select = 2
            this.topic_list[index2].is_error = true
          }
          answers.push(index)
        }
        this.topic_list[index2].answer = answers.join('')
        this.count_select()
      },
      conceal (item2, index2) {
        this.topic_list[index2].show_answer = !this.topic_list[index2].show_answer
      },
      paper (type) { // 交卷
        let _this = this
        let question_info = []
        let grade = 0
        let true_num = 0
        let error_num = 0

        for (let i = 0; i < this.topic_list.length; i++) {
          if (this.topic_list[i].is_error) {
            error_num += 1
          } else {
            true_num += 1
          }
          let data = {
            info_id: _this.topic_list[i].info_id, //1
            option: _this.topic_list[i].answer //2
          }
          question_info.push(data)
        }
        grade = true_num

        let info = {
          course_id: this.course_id,
          grade: grade,
          true_num: true_num,
          error_num: error_num,
          cnt_course: this.cnt_course,
          use_time: this.use_time
        }
        if (this.current_topic < this.topic_list.length) {
          return this.API.SMessage('答题未完成')
        }
        this.$router.push('/okTest?course_type=' + this.course_type + '&directory_id=' + this.directory_id + '&info=' + JSON.stringify(info))
      },
      get_list () {
        this.API.post('user/course_in-get_question_info', {
          course_id: this.course_id,
          directory_id: this.directory_id
        }).then((res) => {
          if (res.errno != 0) {
            this.API.SMessage(res.message)
            return this.$router.back()
          }
          if (res.data.question_list.length < 1) {
            this.API.SMessage('无练习题')
            return this.$router.back()
          }
          for (let i = 0; i < res.data.question_list.length; i++) {
            res.data.question_list[i].answer = null
            res.data.question_list[i].is_error = null
            res.data.question_list[i].show_answer = false
            for (let j = 0; j < res.data.question_list[i].qst_info.length; j++) {
              res.data.question_list[i].qst_info[j].is_select = null
            }
          }
          this.topic_list = res.data.question_list
          this.cnt_course = res.data.cnt_course
        }).catch((err) => {
          console.log(err)
        })
      },
      get_pher_list () {
        this.API.post('user/phar_in-get_question_phar', {
          directory_id: this.directory_id,
          course_id: this.course_id,
          page: 1,
          page_size: 1000
        }).then((res) => {
          if (res.errno == 0) {
            if (res.data.question_list.length < 1) {
              this.API.SMessage('无练习题')
              return this.$router.back()
            }
            for (let i = 0; i < res.data.question_list.length; i++) {
              res.data.question_list[i].answer = null
              res.data.question_list[i].is_error = null
              res.data.question_list[i].show_answer = false
              for (let j = 0; j < res.data.question_list[i].qst_info.length; j++) {
                res.data.question_list[i].qst_info[j].is_select = null
              }
            }
            this.topic_list = res.data.question_list
            this.cnt_course = res.data.cnt_course
          } else {
            this.API.SMessage(res.message)
          }
        })
      }
    },
  }
</script>

<style lang="less" scoped>
    .topic-list-shell {
        height: 70vh;
        overflow-y: scroll;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        font-weight: 400;
        color: #000;
        cursor: text;
    }

    .el-breadcrumb {
        margin-top: 30px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .box {
        width: 1200px;
        margin: 20px 0;
        border: 1px solid #d3d3d3;
    }

    .herd {
        display: flex;
        justify-content: space-between;
        margin: 16px 36px 0 36px;

        .btn {
            width: 92px;
            height: 40px;
            border: 1px solid #2aa9b5;
            border-radius: 5px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2baab5;
            background-color: #fff;
        }

        .nuber {
            width: 62px;
            height: 26px;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 54px;
        }
    }

    .topic {
        margin: 16px 36px 0 36px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 54px;
    }

    .content {
        margin: 40px 36px 0 36px;

        .option-box {
            display: flex;
            align-items: center;
            margin-bottom: 30px;
        }

        .select-box {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 1px solid #acacac;
            margin-right: 20px;
            cursor: pointer;
        }

        .option-val {
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
        }

        .conceal {
            margin: 20px 20px 20px 0;
            width: 170px;
            height: 70px;
            background: #2aaab6;
            border-radius: 5px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
        }

        .ok {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 54px;
        }

        .planning {
            margin-bottom: 30px;
            width: 1090px;
            height: 65px;
            padding-left: 20px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            line-height: 65px;
            border: 1px dashed #dcdcdc;
        }
    }

    /deep/ .van-radio__label {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 54px;
        margin-bottom: 20px;
    }

    .conceals {
        margin: 20px 20px 20px 0;
        width: 170px;
        height: 70px;
        background: #e81826;
        border-radius: 5px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

    /deep/ .van-icon {
        position: relative;
        top: -8px;
        margin-right: 10px;
    }

    .Btn1 {
        position: relative;
        left: 50%;
        top: 32px;
        transform: translate(-50%);
        width: 500px;
        height: 70px;
        background: #2aa9b5;
        border-radius: 5px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 86px;
    }
</style>
